/* The Alt Art Co - holo tilt on product cards (pointer devices only, respects reduced motion). */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover: hover)').matches) return;
  const MAX = 9; // degrees
  document.addEventListener('pointermove', (e) => {
    const card = e.target.closest && e.target.closest('[data-aac-tilt]');
    document.querySelectorAll('[data-aac-tilt].is-tilting').forEach((c) => { if (c !== card) reset(c); });
    if (!card) return;
    const r = card.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    card.classList.add('is-tilting');
    card.style.transform = `perspective(900px) rotateX(${(0.5 - y) * MAX}deg) rotateY(${(x - 0.5) * MAX}deg) translateY(-4px)`;
    card.style.setProperty('--hx', `${x * 100}%`); card.style.setProperty('--hy', `${y * 100}%`);
  }, { passive: true });
  function reset(c) { c.classList.remove('is-tilting'); c.style.transform = ''; }
  document.addEventListener('pointerleave', () => document.querySelectorAll('[data-aac-tilt].is-tilting').forEach(reset));
})();


/* product page: gallery thumbs, qty stepper, recommendations */
(() => {
  const g = document.querySelector('[data-aac-gallery]');
  if (g) g.addEventListener('click', (e) => { const t = e.target.closest('[data-full]'); if (!t) return;
    const img = g.querySelector('[data-aac-main]'); if (t.dataset.ratio) img.closest('.aac-pdp__main').style.aspectRatio = t.dataset.ratio; img.removeAttribute('srcset'); img.removeAttribute('width'); img.removeAttribute('height'); img.src = t.dataset.full; if (t.dataset.alt) img.alt = t.dataset.alt;
    g.querySelectorAll('[data-full]').forEach((x) => { x.classList.toggle('is-on', x === t); x.toggleAttribute('aria-current', x === t); }); });
  document.querySelectorAll('[data-aac-qty]').forEach((q) => q.addEventListener('click', (e) => { const b = e.target.closest('[data-d]'); if (!b) return;
    const i = q.querySelector('input'); i.value = Math.max(1, (+i.value || 1) + +b.dataset.d); }));
  const recs = document.querySelector('[data-aac-recs]');
  if (recs && !recs.children.length) fetch(recs.dataset.url).then((r) => r.text()).then((h) => {
    const d = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-aac-recs]'); if (recs.dataset.aacSameSet) return;   // same-set strip already in place
    if (d && d.innerHTML.trim()) recs.innerHTML = d.innerHTML; else if (!recs.dataset.aacSameSet) recs.remove();
  }).catch(() => { if (!recs.dataset.aacSameSet) recs.remove(); });
})();
